import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import Lottie from "lottie-react";
import notFoundAnimation from "../../../assets/animations/notfound.json";
import "../../../assets/css/general/not-found/NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="nf-wrapper">
      <div className="nf-blob nf-blob-1" />
      <div className="nf-blob nf-blob-2" />
      <div className="nf-blob nf-blob-3" />
      <div className="nf-circle nf-circle-tl" />
      <div className="nf-circle nf-circle-br" />

      <div className="nf-container text-center">
        <Lottie
          animationData={notFoundAnimation}
          loop={true}
          style={{ width: 300, height: 300, margin: '0 auto', background: 'transparent' }}
        />

        <h2 className="nf-title">Page Not Found</h2>

        <p className="nf-subtitle">
          Oops! Looks like this page doesn't exist.
          <br />
          Let's get you back to our handmade treasures! 🧡
        </p>

        <div className="nf-divider" />

        <Button className="nf-btn" onClick={() => navigate("/")}>
          <span className="nf-btn-icon">🏠</span>
          Go Back Home
        </Button>
      </div>
    </div>
  );
};

export default NotFound;